<i18n lang="json">
{
  "zh-cn": {
    "title": "最新充值记录",
    "all_record": "所有记录"
  },
  "en": {
    "title": "Latest Recharge Records",
    "all_record": "All Records"
  }
}
</i18n>

<script setup lang="ts">
import apiFund from '@/api/modules/fund'
import useRechargeStore from '@/store/modules/recharge'
import { useI18n } from 'vue-i18n'
import { toast } from 'vue-sonner'

// 表格数据
import table from './table_list'

const ViewRecharge = defineAsyncComponent(() =>
  import('@/views/fund_manage/recharge/components/ViewRecharge/index.vue'),
)

const { t } = useI18n()
const loading = ref(false)
const rechargeStore = useRechargeStore()

// 查询表单
const query_data = ref({
  created_at: [],
  audit_status: undefined,
})
// 表格分页
const table_query = ref({
  _action: 'getData',
  page: 1,
  perPage: 4,
})
const table_total = ref(0)
const table_list = ref([])

const RechargeFundsRef = ref()
const ViewRechargeRef = ref()

function getDataList() {
  loading.value = true
  apiFund.getRechargesList({
    ...query_data.value,
    ...table_query.value,
  }).then((res) => {
    if (res.status === 0) {
      table_list.value = res.data.items
      table_total.value = res.data.total
    }
    else {
      toast.error(res.msg)
    }
  }).finally(() => {
    loading.value = false
  })
}
const screen_list = ref(table())
onMounted(() => {
  getDataList()
  if (rechargeStore.openRecharge) {
    setTimeout(() => {
      RechargeFundsRef.value.show()
      rechargeStore.openRecharge = false
    }, 1)
  }
})
</script>

<template>
  <FaPageMain
    v-loading="loading"
    class="m-0 mb-5 min-h-95 p-0 shadow-[0px_0px_16px_0px_rgba(0,0,0,0.03)]"
    main-class="p-4 flex-1 flex flex-col justify-between"
  >
    <p>
      <span class="font-size-5 c-[var(--el-color-primary-dark-6)] font-bold">{{ t('title') }}</span>

      <RouterLink
        v-slot="{ navigate }"
        class="float-right"
        :to="{
          name: 'FundManageRecharge',
        }"
        custom
      >
        <el-button
          type="primary"
          @click="navigate()"
        >
          {{ t('all_record') }}
        </el-button>
      </RouterLink>
    </p>
    <div>
      <el-table class="mt-4" :data="table_list">
        <template v-for="(item, index) in screen_list">
          <el-table-column
            v-if="item.show"
            :key="index"
            :prop="item.prop"
            :label="item.label"
            :min-width="item.minWidth"
            :align="item.align"
          >
            <template #default="{ row }">
              <template v-if="item.prop === 'pay_type'">
                <!-- 支付方式 -->
                <FaIcon class="size-6 align-middle" :name="rechargeStore.findRechargePayList(row.pay_type).pay_logo_icon" />
                <span class="inline-block pl-1 align-middle">{{ rechargeStore.findRechargePayList(row.pay_type).label }}</span>
              </template>
              <template v-else-if="item.prop === 'voucher'">
                <!-- 支付凭证 -->
                <ImagePreview :src="row.voucher ? row.voucher : ''" :width="60" :height="60" />
              </template>
              <template v-else-if="item.prop === 'audit_status'">
                <!-- 审核状态 -->
                <span :class="rechargeStore.findRechargeAuditStatusList(row.audit_status).tag_type">{{ rechargeStore.findRechargeAuditStatusList(row.audit_status).label }}</span>
              </template>
            </template>
          </el-table-column>
        </template>

        <el-table-column :label="t('common.operate')" min-width="80" align="center" fixed="right">
          <template #default="{ row }">
            <el-link type="primary" :underline="false" @click="ViewRechargeRef.show(row.id)">
              {{ t('common.view') }}
            </el-link>
          </template>
        </el-table-column>
      </el-table>
      <ViewRecharge ref="ViewRechargeRef" />
    </div>
  </FaPageMain>
</template>

<style scoped>
.el-table {
  :deep(.el-table__header) {
    min-height: 45px;
  }

  :deep(.el-table__row) {
    .cell {
      min-height: 45px;
      line-height: 45px;
    }
  }
}
</style>
